<template>
  <button
    type="button"
    class="w-full flex items-center gap-4 pr-4"
    @click="setOpen(true)"
  >
    <span class="sr-only">{{ trans.get('miliboo.common.open') }} {{ item.label }}</span>
    <img
      v-if="item.image_url"
      class="size-14 object-cover"
      :src="`${imageProxyUrl}rs:fill:64:64:0/plain/${item.image_url}`"
    >
    <span
      class="text-left flex-grow text-gray-600 text-base"
      :class="{ 'p-4': !item.image_url }"
    >
      {{ item.label }}
    </span>
    <v-icon-chevron-r class="h-6 w-6 text-gray-700" />
  </button>
  <TransitionRoot
    as="template"
    :show="open"
  >
    <Dialog
      as="div"
      class="fixed inset-0 flex z-40"
      @close="setOpen(false)"
    >
      <TransitionChild
        as="template"
        enter="transition-opacity ease-linear duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="transition-opacity ease-linear duration-300"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <DialogOverlay class="fixed inset-0 bg-black bg-opacity-0 transition-opacity" />
      </TransitionChild>
      <TransitionChild
        as="template"
        enter="transition ease-in-out duration-300 transform"
        enter-from="-translate-x-full"
        enter-to="translate-x-0"
        leave="transition ease-in-out duration-300 transform"
        leave-from="translate-x-0"
        leave-to="-translate-x-full"
      >
        <div class="relative bg-white max-w-xs w-full shadow-xl pb-12 flex flex-col overflow-y-auto">
          <TheMainMenuMobilePannelPannelHeader
            :set-open="setOpen"
            :item="item"
            :parent="parent"
            :image-proxy-url="imageProxyUrl"
            @close="$emit('close')"
          />
          <nav
            :aria-label="item.label"
            class="divide-y divide-gray-800 border-y border-gray-800"
          >
            <section
              v-for="sub in item.child_menu"
              :key="sub.label"
              class="z-10 p-4"
            >
              <h3 class="text-gray-900 hover:text-gray-500 font-semibold text-base">
                <a :href="`/${sub.slug}`">
                  {{ sub.label }}
                </a>
              </h3>
              <ul
                v-if="sub.child_menu.length > 0"
                class="pt-3 space-y-3"
              >
                <li
                  v-for="i in sub.child_menu"
                  :key="i.label"
                >
                  <a
                    :href="`/${i.slug}`"
                    class="hover:text-gray-500 text-gray-900 text-base"
                  >
                    {{ i.label }}
                  </a>
                </li>
              </ul>
            </section>
          </nav>
        </div>
      </TransitionChild>
    </Dialog>
  </TransitionRoot>
</template>
<script setup>
import { inject } from 'vue';
import {
  Dialog,
  DialogOverlay,
  TransitionChild,
  TransitionRoot,
} from '@headlessui/vue';
import useOpen from '../../composables/useOpen';
import TheMainMenuMobilePannelPannelHeader from './TheMainMenuMobilePannelPannelHeader.vue';

defineProps({
  item: {
    type: Object,
    required: true,
  },
  parent: {
    type: Object,
    required: true,
  },
  imageProxyUrl: {
    type: String,
    required: true,
  },
});

defineEmits(['close']);

const trans = inject('translate');

const { open, setOpen } = useOpen();

</script>
